import React from 'react';


function profile(props) {

    return(
        <div className='profile-card'>
            <div className="profile-box">
                <div className="profile_img">
                    <img src="./images/image-jeremy.png" alt="" />
                </div>
                <div className="profile-info">
                    <span>Report for</span>
                    <div className="full-name">
                        <h2 className='firstName'>jeremy</h2>
                        <h2 className="lastName">robson</h2>
                    </div>
                </div>
            </div>
            <div className="timely-btns">
                <span onClick={props.handleTimeFrame} data-id="daily">Daily</span>
                <span onClick={props.handleTimeFrame} data-id="weekly" className="active">Weekly</span>
                <span onClick={props.handleTimeFrame} data-id="monthly">Monthly</span>
            </div>
        </div>
    )
}

export default profile